import { Module, VuexModule, Action } from "vuex-module-decorators";
import api from "@/api/invest_corrent";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async info(params: any) {
    return api.info(params);
  }
  @Action
  async save(params: any) {
    return api.save(params);
  }
  @Action
  async save_ground(params: any) {
    return api.save_ground(params);
  }
  @Action
  async add_price(params: any) {
    return api.add_price(params);
  }
  @Action
  async submit(params: any) {
    return api.submit(params);
  }
}
